
import { defineComponent } from "vue";

export default defineComponent({
  name: "node",
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isObject(obj: Record<string, unknown>): boolean {
      return typeof obj === "object" && obj !== null;
    },
    isExists(val: string): string {
      return String(val) ? String(val) : "'empty'";
    },
  },
});
